import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "documents" }
const _hoisted_2 = { class: "flex flex-row gap-4" }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-row gap-1"
}
const _hoisted_4 = { class: "flex flex-row gap-4" }
const _hoisted_5 = { class: "flex flex-row gap-1" }

import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

import { maskCPF, maskCNPJ, maskDateBR } from "@/common/utils/mask";

import {
  baseInput,
  baseDate,
  baseSelect,
  baseTextarea,
} from "@/common/components";

import type {
  EmployeeType,
  EmployeePayloadType,
} from "@/common/types/employee";


export default /*@__PURE__*/_defineComponent({
  __name: 'employee',
  props: {
    data: {},
    title: {},
    width: { default: "100%" },
    isPatch: { type: Boolean, default: false }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const defaultData = {
  name: "",
  social_name: null,
  role: null,
  sector: null,
  registration_number: null,
  document_type: "",
  document_name: "",
  document_number: "",
  status: "ACTIVE",
  ges_name: null,
  ges_status: null,
  ges_description: null,
  start_date: null,
  end_date: null,
  description: null,
};

const documentOptions = computed(() => [
  {
    option: t("common.labels.cpf"),
    value: "CPF",
  },
  {
    option: t("common.labels.cnpj"),
    value: "CNPJ",
  },
  {
    option: t("common.labels.other"),
    value: "OTHER",
  },
]);

const statusOptions = computed(() => [
  {
    option: t("common.labels.active"),
    value: "ACTIVE",
  },
  {
    option: t("common.labels.inactive"),
    value: "INACTIVE",
  },
]);

const payload = ref<EmployeePayloadType>({ ...defaultData });

function update(key: keyof typeof payload.value) {
  if (!props.isPatch) {
    emit("update-data", payload.value);
    return;
  }

  emit("update-data", { [key]: payload.value[key] });
}

function documentMask(value: any) {
  if (payload.value.document_type === "CPF") return maskCPF(value);

  if (payload.value.document_type === "CNPJ") return maskCNPJ(value);

  return value;
}

function changeDocument(type: any) {
  payload.value.document_name = type;
  payload.value.document_number = documentMask(payload.value.document_number);

  if (type === "OTHER") {
    payload.value.document_name = "";
  }

  if (!props.isPatch) {
    emit("update-data", payload.value);
    return;
  }

  emit("update-data", {
    document_name: payload.value.document_name,
    document_number: payload.value.document_number,
  });
}

watchEffect(() => {
  if (props.data) {
    payload.value = {
      ...defaultData,
      ...props.data,
    };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "form-content",
    style: _normalizeStyle({ width: __props.width })
  }, [
    _createElementVNode("form", null, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
        value: payload.value.name,
        placeholder: _unref(t)('common.placeholders.name'),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (update('name')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " *", 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.social_name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.social_name) = $event)),
        value: payload.value.social_name,
        onInput: _cache[3] || (_cache[3] = ($event: any) => (update('social_name')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.social_name")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value"]),
      _createElementVNode("div", _hoisted_1, [
        (payload.value.document_type === 'OTHER')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(baseSelect), {
                  class: "flex-2",
                  modelValue: payload.value.document_type,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.document_type) = $event)),
                  value: payload.value.document_type,
                  options: documentOptions.value,
                  onChange: changeDocument
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.document_type")) + " * ", 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "value", "options"]),
                _createVNode(_unref(baseInput), {
                  class: "flex-3",
                  modelValue: payload.value.document_name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((payload.value.document_name) = $event)),
                  value: payload.value.document_name,
                  placeholder: _unref(t)('common.placeholders.describe'),
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (update('document_name')))
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " *", 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "value", "placeholder"])
              ]),
              _createVNode(_unref(baseInput), {
                class: "flex-4",
                modelValue: payload.value.document_number,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((payload.value.document_number) = $event)),
                value: payload.value.document_number,
                placeholder: _unref(t)('common.labels.number'),
                mask: documentMask,
                onInput: _cache[8] || (_cache[8] = ($event: any) => (update('document_number')))
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.number")) + " *", 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value", "placeholder"])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(baseSelect), {
                class: "flex-2",
                modelValue: payload.value.document_type,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((payload.value.document_type) = $event)),
                value: payload.value.document_type,
                options: documentOptions.value,
                onChange: changeDocument
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.document_type")) + " * ", 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value", "options"]),
              _createVNode(_unref(baseInput), {
                class: "flex-3",
                modelValue: payload.value.document_number,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((payload.value.document_number) = $event)),
                value: payload.value.document_number,
                placeholder: _unref(t)('common.labels.number'),
                mask: documentMask,
                onInput: _cache[11] || (_cache[11] = ($event: any) => (update('document_number')))
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.number")) + " *", 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value", "placeholder"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(baseSelect), {
          class: "flex-1",
          modelValue: payload.value.status,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((payload.value.status) = $event)),
          value: payload.value.status,
          options: statusOptions.value,
          onChange: _cache[13] || (_cache[13] = ($event: any) => (update('status')))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.status")), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value", "options"]),
        _createVNode(_unref(baseInput), {
          class: "flex-1",
          modelValue: payload.value.registration_number,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((payload.value.registration_number) = $event)),
          value: payload.value.registration_number,
          onInput: _cache[15] || (_cache[15] = ($event: any) => (update('registration_number')))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("employee.labels.registration_number")), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value"])
      ]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.role,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((payload.value.role) = $event)),
        value: payload.value.role,
        onInput: _cache[17] || (_cache[17] = ($event: any) => (update('role')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("employee.labels.role")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.sector,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((payload.value.sector) = $event)),
        value: payload.value.sector,
        onInput: _cache[19] || (_cache[19] = ($event: any) => (update('sector')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("employee.labels.sector")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.ges_name,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((payload.value.ges_name) = $event)),
        value: payload.value.ges_name,
        onInput: _cache[21] || (_cache[21] = ($event: any) => (update('ges_name')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("employee.labels.ges_name")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value"]),
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.ges_status,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((payload.value.ges_status) = $event)),
        value: payload.value.ges_status,
        options: statusOptions.value,
        onChange: _cache[23] || (_cache[23] = ($event: any) => (update('ges_status')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("employee.labels.ges_status")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options"]),
      _createVNode(_unref(baseTextarea), {
        modelValue: payload.value.ges_description,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((payload.value.ges_description) = $event)),
        value: payload.value.ges_description,
        onInput: _cache[25] || (_cache[25] = ($event: any) => (update('ges_description')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("employee.labels.ges_description")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(baseDate), {
          modelValue: payload.value.start_date,
          "onUpdate:modelValue": [
            _cache[26] || (_cache[26] = ($event: any) => ((payload.value.start_date) = $event)),
            _cache[27] || (_cache[27] = ($event: any) => (update('start_date')))
          ],
          value: payload.value.start_date,
          required: true,
          "value-mask": "YYYY-MM-DD",
          placeholder: "--/--/----"
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("employee.labels.start_date")), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value"]),
        _createVNode(_unref(baseDate), {
          modelValue: payload.value.end_date,
          "onUpdate:modelValue": [
            _cache[28] || (_cache[28] = ($event: any) => ((payload.value.end_date) = $event)),
            _cache[29] || (_cache[29] = ($event: any) => (update('end_date')))
          ],
          value: payload.value.end_date,
          required: true,
          "value-mask": "YYYY-MM-DD",
          placeholder: "--/--/----"
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("employee.labels.end_date")), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value"])
      ]),
      _createVNode(_unref(baseTextarea), {
        modelValue: payload.value.description,
        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((payload.value.description) = $event)),
        value: payload.value.description,
        placeholder: _unref(t)('common.placeholders.describe'),
        onInput: _cache[31] || (_cache[31] = ($event: any) => (update('description')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"])
    ])
  ], 4))
}
}

})